<div *ngIf="pdfSrc">
    <iframe title="Vista previa del documento PDF" [src]="pdfSrc | safeUrl" width="100%" height="500px"></iframe>
</div>
